import * as React from "react";
import { SVGProps } from "react";
function SvgArrowRightIconBold(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.854 1.146a.5.5 0 0 0 0 .708l3.97 3.97a.25.25 0 0 1 0 .353l-3.97 3.97a.5.5 0 0 0 0 .707l.792.792a.5.5 0 0 0 .707 0l5.293-5.292a.5.5 0 0 0 0-.708L2.353.354a.5.5 0 0 0-.707 0l-.792.792Z"
        fill="#16A085"
      />
    </svg>
  );
}
export default SvgArrowRightIconBold;
